export default __webpack_public_path__ + "static/media/user-plus.064cbca1.svg";